import styled from 'styled-components';
import { color } from 'styles/colors';

export const container = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const CarouselContainer: any = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  overflow: hidden;
  scroll-behavior: smooth;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
  transition: all ease 0.5s;
`;

export const CarouselItem: any = styled.div`
  scroll-snap-align: center;
  flex: 0 0 auto;
  width: 100%;
  height: auto;
  border-radius: 5px;
`;

interface ImageTagProps {
  objectFitImg: 'cover' | 'fill' | 'contain';
}

export const imageTag: any = styled.div<ImageTagProps>`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  > img {
    width: 100%;
    height: 100%;
    object-fit: ${props => props.objectFitImg};
  }
`;

export const clicks = styled.div`
  position: absolute;
  bottom: 0px;
  right: 0px;
  border-top-left-radius: 5px;
  background-color: ${color.interface.darkgray2};
  padding: 1px 5px;
  font-weight: 900;
  font-size: 1.3rem;
  z-index: 10;

  > p {
    font-size: 1rem;
    color: ${color.interface.white};
  }
`;

export const ButtonRight: any = styled.button`
  all: unset;
  position: absolute;
  right: 0;
  top: 45%;
  cursor: pointer;
  > svg {
    font-size: 3rem;
    color: ${color.interface.white};
  }
`;

export const ButtonLeft: any = styled.button`
  all: unset;
  position: absolute;
  left: 0;
  top: 45%;
  cursor: pointer;
  > svg {
    font-size: 3rem;
    color: ${color.interface.white};
  }
`;

export const containerBallsInsideCarousel: any = styled.div`
  position: absolute;
  bottom: 5px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  gap: 1rem;
  padding: 0.5rem 0;
`;

export const containerBallsOutsideCarousel: any = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  gap: 1rem;
  padding: 0.5rem 0;
`;

export const ball: any = styled.div`
  min-width: 12px;
  min-height: 5px;
  border-radius: 5px;
  background-color: ${(props: any) =>
    props.selected ? props.checked : props.noChecked};
  border: 1px solid ${color.interface.darkgray2};
`;

export const centralizeNotice = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  > p {
    font-size: 1.4rem;
    font-weight: 900;
  }
`;
